<template>
    <div class="container-fluid p-0">
        <div class="row">
            <div class="col-12 text-right p-0 responsive-center">
                <el-select size="large"
                           class="select-primary btn-one-size-dropdown"
                           @change="showListChange"
                           v-model="taskList">
                    <el-option v-for="option in [
                            {value: false, label: this.$t('Open Tasks')},
                            {value: true, label: this.$t('Completed Tasks')}
                        ]"
                               :value="option.value"
                               :label="$t(option.label)"
                               :key="option.value">
                    </el-option>
                </el-select>
                &nbsp;
                <p-button class="mr-2 ml-2 task-create-button  btn-one-size-dropdown" round type="default" @click="() => this.$router.push({ name: 'TaskCreate' })">
                    {{$t('Create Task')}}
                </p-button>
            </div>
        </div>
        <div class="card-body row pt-0">
            <div class="col-12 p-0 table-responsive">
                <el-table class="table-striped"
                          v-loading="loading"
                          :element-loading-text="$t('Loading...')"
                          header-row-class-name="text-primary"
                          :data="tasks"
                          row-key="id"
                          :expand-row-keys="tasks.filter(task => task.subtasks).map(task => task.id)"
                          :row-class-name="getRowClassName"
                          @sort-change="sortChange"
                          :default-sort="{prop: sf, order: 'descending'}"
                >
                    <el-table-column v-if="window.width >= 768" key="dueDate"
                                     :sortable="true"
                                     :width="'140px'"
                                     :min-width="'100px'"
                                     prop="dueDate"
                                     :formatter="dateFormatter"
                                     :label="$t('Due date')"/>
                    <el-table-column v-if="window.width >= 768" key="title"
                                     :sortable="true"
                                     :width="'auto'"
                                     :min-width="'100px'"
                                     prop="title"
                                     :label="$t('Title')"/>
                    <el-table-column v-if="window.width >= 768" key="assignee"
                                     :sortable=true
                                     :width="'auto'"
                                     :min-width="'100px'"
                                     :formatter="userFormatter"
                                     :label="$t('Concern')">
                        <template slot-scope="scope">
                            <div v-if="scope.row.assigneeType === 'user'">
                                <span>{{ scope.row.assignee | formatDisplayName }}</span>
                            </div>
                            <div v-else>
                                <span>{{ scope.row.assignee.title }}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="window.width >= 1000 && !hideTrigger" key="trigger.title"
                                     :sortable="true"
                                     :width="'auto'"
                                     :min-width="'100px'"
                                     prop="trigger.title"
                                     :formatter="languageString"
                                     :label="$t('Trigger')"/>
                    <el-table-column v-if="window.width < 768" key="smallWindow"
                                     :sortable="false"
                                     :width="'auto'"
                                     :min-width="'100px'">
                        <template slot-scope="props">
                            <div class="row">
                                <div class="col-4 title nowrap">{{$t('Due date')}}</div>
                                <div class="col-8">{{props.row.dueDate | formatDate }}</div>
                            </div>
                            <div class="row" style="margin-top: 3px">
                                <div class="col-4 title nowrap">{{$t('Title')}}</div>
                                <div class="col-8">{{props.row.title}}</div>
                            </div>
                            <div class="row" style="margin-top: 3px">
                                <div class="col-4 title nowrap">{{$t('Concern')}}</div>
                                <div class="col-8">
                                    <div v-if="props.row.assigneeType === 'user'">
                                        <span>{{ props.row.assignee | formatDisplayName }}</span>
                                    </div>
                                    <div v-else>
                                        <span>{{ props.row.assignee.title }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row" style="margin-top: 3px" v-if="!hideTrigger">
                                <div class="col-4 title">{{$t('Trigger')}}</div>
                                <div class="col-8">{{props.row.trigger.title | languageString}}</div>
                            </div>
                            <div class="row" style="margin-top: 7px">
                                <div class="col-4 title nowrap">{{$t('Actions')}}</div>
                                <div class="col-8">
                                    <p-button v-if="remove" class="mr-2" round type="danger" size="sm" icon @click="remove(props)">
                                        <i class="fa fa-times"/>
                                    </p-button>
                                    <p-button v-if="edit" class="mr-2" round type="success" size="sm" icon @click="edit(props)">
                                        <i class="fa fa-edit"/>
                                    </p-button>
                                    <p-button v-if="view" class="mr-2" round type="success" size="sm" icon @click="view(props)">
                                        <i class="fa fa-eye"/>
                                    </p-button>
                                    <p-button v-if="complete && props.row.completed" class="mr-2" round type="success" size="sm" icon @click="complete(props.row._id, !props.row.completed)">
                                        <i class="fa fa-check"/>
                                    </p-button>
                                    <p-button v-else-if="complete && !props.row.completed" class="mr-2" round size="sm" icon @click="complete(props.row._id, !props.row.completed)">
                                        <i class="fa fa-check"/>
                                    </p-button>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
<!--                    <el-table-column v-for="column in columns"-->
<!--                                     :key="column.name"-->
<!--                                     :sortable="column.sortable"-->
<!--                                     :width="column.width || 'auto'"-->
<!--                                     :min-width="column.minWidth || '100px'"-->
<!--                                     :prop="column.name"-->
<!--                                     :formatter="column.formatter"-->
<!--                                     :label="$t(column.text)"/>-->
                    <el-table-column v-if="window.width >= 768"
                            :min-width="170"
                            :width="170"
                            align="center"
                            fixed="right"
                            class-name="td-actions"
                            :label="$t('Actions')">
                        <template slot-scope="props">
                            <p-button v-if="remove" round type="danger" size="sm" icon @click="remove(props)">
                                <i class="fa fa-times"/>
                            </p-button>
                            <p-button v-if="edit" round type="success" size="sm" icon @click="edit(props)">
                                <i class="fa fa-edit"/>
                            </p-button>
                            <p-button v-if="view" round type="success" size="sm" icon @click="view(props)">
                                <i class="fa fa-eye"/>
                            </p-button>
                            <p-button v-if="complete && props.row.completed" round type="success" size="sm" icon @click="complete(props.row._id, !props.row.completed)">
                                <i class="fa fa-check"/>
                            </p-button>
                            <p-button v-else-if="complete && !props.row.completed" round size="sm" icon @click="complete(props.row._id, !props.row.completed)">
                                <i class="fa fa-check"/>
                            </p-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="pagination" class="col-12">
                <div class="col-sm-12 pt-3 m-0">
                    <p-pagination class="pull-center"
                                  :value="pagination.currentPage"
                                  @input="changePage"
                                  :per-page="pagination.perPage"
                                  :total="pagination.total">
                    </p-pagination>
                </div>
            </div>
        </div>

        <task-dialog v-model="task" :show="showDialog" :handle-close="() => {this.showDialog=false}" :set-completed="complete"/>

    </div>
</template>

<script>
  import { Checkbox } from 'element-ui'
  import Vue from 'vue'
  import { Select, Option, Table, TableColumn, Input } from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import { mapActions, mapState } from 'vuex'
  import Modal from '../../Dashboard/Components/BasicModal'
  import List from '../../Dashboard/Components/BasicList'
  import TaskDialog from '../../Dashboard/Components/TaskDialog'
  import PButton from '../../UIComponents/Button'

  Vue.use(Select)
  Vue.use(Option)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Input)

  export default {
    name: 'Tasks',
    components: { TaskDialog, Checkbox, PPagination, Modal, List, PButton },
    data () {
      return {
        loading: false,
        columns: [
          { name: 'dueDate', text: 'Due date', sortable: false, align: 'left', width: '110px', formatter: this.dateFormatter },
          { name: 'title', text: 'Title', sortable: false, align: 'left' },
          { name: 'assignee', text: 'Concerned', sortable: false, align: 'left', formatter: this.userFormatter },
          { name: 'trigger.title', text: 'Trigger', sortable: false, align: 'left', formatter: this.languageString }
        ],
        actions: [
          { label: 'Create Task', click: () => this.$router.push({ name: 'TaskCreate' }) }
        ],
        subtaskColumns: [
            { name: 'createdAt', text: 'Created at', sortable: false, align: 'left', width: '150px', formatter: this.dateFormatter },
            { name: 'title', text: 'Title', sortable: false, align: 'left' },
            { name: 'createdBy', text: 'Created by', sortable: false, align: 'left', formatter: this.userFormatter}
        ],
        showDialog: false,
        task: null,
        sf: 'dueDate',
        so: 'desc',
        taskList: false,
        showCompleted: false,
        propsIndex: null,
        hideTrigger: true,
        window: {
          width: 0
        }
      }
    },
    computed: {
      ...mapState('user/tasks/pagination', {
          tasks: state => state.items,
          pagination: state => state
      })
    },
    created() {
      window.addEventListener('resize', this.handleResize)
      this.handleResize();
    },
    async mounted () {
      if (!this.$auth.user.isOwner && !this.$auth.user.isLeader) {
          return this.$router.push({ name: 'TeamContainer' })
      }

      this.init()
    },
    methods: {
      ...mapActions('user/tasks/pagination', ['getTasks']),
      ...mapActions('user/tasks', ['removeTask', 'updateTask', 'setCompleted']),
      async init () {
        const newPage = parseInt(this.$route.query.page, 10) || 1
        await this.getTasks({ perPage: this.pagination.perPage, page: newPage, sf: this.sf, so: this.so, completed: this.showCompleted})
        if (this.propsIndex) {
          this.task = this.tasks[this.propsIndex]
        }
      },
      dateFormatter: function (row, column, cellValue) {
        return this.$options.filters.formatDate(cellValue)
      },
      userFormatter: function (row, column, cellValue) {
          return this.$options.filters.formatDisplayName(cellValue)
      },
      languageString: function (row, column, cellValue) {
        return this.$options.filters.languageString(cellValue)
      },
      changePage (val) {
        const page = val > 1 ? val : undefined
        this.$router.push({ ...this.$router.currentRoute, query: { ...this.$route.query, page } })
      },
      getRowClassName ({ row, rowIndex }) {
        return 'row-expand-cover'
      },
      edit: function (props) {
          this.$router.push({ name: 'TaskEdit', params: { id: props.row._id } })
      },
      remove: function (props) {
          this.$dialog.confirm(this.$t(`Confirm`), this.$t('Are you sure to delete {task}?', { task: props.row.title }), this.$t('Delete'))
              .then(async () => {
                  await this.removeTask({id: `${props.row._id}`})
                  await this.init()
              })
      },
      view: function (props) {
          this.propsIndex = props.$index
          this.task = props.row
          this.showDialog = true
      },
      cancel: function () {
          this.showDialog = false
      },
      async complete(id, completed=true, type='task') {
        this.setCompleted({ id: id, completed: `${completed ? 'completed': 'notCompleted'}` })
        if (type === 'task') {
            this.showDialog = false
        }

         setTimeout(() => {
             this.init()
         }, 200)
      },
      sortChange: function ({ column, prop, order }) {
          this.sf = prop || 'dueDate'
          this.so = (order || 'descending') === 'ascending' ? 'asc' : 'desc'
          this.init()
      },
      showListChange: function (value) {
          this.showCompleted = value || false
          this.init()
      },
      handleResize() {
        this.window.width = window.innerWidth
      }
    },
    watch: {
      '$route.query.page' (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.init()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
    .el-input {
        display: block;
        /*width: 128.48px;*/
    }

    .el-table .cell {
        word-break: break-word;
        white-space: pre-wrap;
    }

    .el-table__expand-column {
        padding: 0 !important;
        border-right: none !important;

        .cell {
            width: 0;
            padding: 0;
        }
        .el-table__expand-icon {
            height: 0;
            width: 0;
        }
    }

    .el-dialog__body {
        padding: 0 20px;
    }

    .inline {
        display: inline-block;
    }

    .expanded-container {
        margin-left: 0px;
    }

    .row-expand-cover .el-table__expand-icon {
        visibility: hidden;
    }

    .card-task {
        max-width: 800px !important;
        margin: auto;
        padding-bottom: 2em;

        .text {
            font-weight: 400;
            font-size: 1.5em;
            line-height: initial;
            small {
                font-size: 0.75em;
                font-weight: 300;
            }
        }

        .card-content {
            padding-top: 1em;
            text-align: justify;
        }

        &-date {
            text-align: right;
            padding-top: 7px;
        }
    }

    .nowrap {
      white-space: nowrap;
    }

    @media (max-width: 590px) {
      .btn-one-size {
        width: 91%;
        padding-left: 15px;
        padding-right: 15px;
      }

      .btn-one-size-dropdown {
        width: 100%;
        padding-left: 15px;
        padding-right: 15px;
      }

      .task-create-button {
        width: 91%;
        margin-left: 5px;
        margin-right: 5px;
      }

      .responsive-center {
          text-align: left !important;
      }
    }
    
</style>
